<template>
  <div :class="{wrap: true, marked: (seconds < 60)}" v-if="activeLock">
    Ditt bokning är reserverad. Du behöver slutföra din bokning innan följande tid är slut: <span class="time">{{ time }}</span>
    &nbsp;<button class="small white border" @click="extend_time()" v-if="true">Förläng</button>
  </div>

</template>

<script>
import { mapMutations } from 'vuex';
import moment from 'moment';
import API from '@/classes/API';

export default {
  props: {
    currentlyPaying: {
      default: false,
    },
  },
  components: {
  },
  data() {
    return {
      time: '',
      seconds: 0,
      intervalRef: null,
    };
  },
  created() {
    // this.intervalRef = setInterval(this.calculate_time, 1000);
  },
  mounted() {
  },
  destroyed() {
    // clearInterval(this.intervalRef);
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
      'markReservationsAsLost',
      'saveCartLocking',
    ]),
    tryAgain() {
      if (!this.$store.state.lockingActive) {
        return false;
      }

      this.closeAllModals();

      const props = {};

      if (this.currentlyPaying || this.$route.name === 'payment') {
        props.forceSyncAll = true;
      }

      setTimeout(() => {
        this.openModal(['BookingCancelled', props]);
      }, 1);

      this.$store.state.lockingActive = false;

      return true;
    },
    calculate_time() {
      this.seconds = moment.utc(`${this.$store.state.lockingBeforeTime}`, 'YYYY-MM-DD HH:mm:ss').diff(moment(), 'seconds') - 2;

      if (this.seconds === 0) {
        // clearInterval(this.intervalRef);
        this.tryAgain();
      }

      let m = 0;
      let s = 0;

      if (this.seconds >= 60) {
        m = Math.floor(this.seconds / 60);
        s = this.seconds - (m * 60);
      } else {
        m = 0;
        s = this.seconds;
      }

      if (m < 10) {
        if (!m) {
          m = 0;
        } else {
          m = `0${m}`;
        }
      }
      if (s < 10) {
        s = `0${s}`;
      }

      this.time = `${m}:${s}`;

      this.$emit('update', this.seconds);
    },
    async extend_time() {
      const order = this.$route.query.order;
      const orderCode = this.$route.query.code;
      const { code, before_time } = await API.post(`extend-time/${this.$store.state.lockingCode}?order=${order}&code=${orderCode}`);

      this.saveCartLocking({
        code,
        beforeTime: before_time,
      });
    },
  },
  computed: {
    activeLock() {
      return this.seconds > 0 && this.$store.state.lockingActive;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.wrap
  width 100%
  text-align: center
  &.marked
    font-weight: bold
    color warning
.time
  width 4em
  text-align: left;
  display: inline-block;
</style>



// WEBPACK FOOTER //
// BookingTimer.vue?7214dfdd